export const formatDateToHumanReadable = (isoString: string): string => {
	return new Date(isoString).toLocaleString(undefined, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
};
